module.exports = __webpack_public_path__ + "img/base.d540d781.png";